module.exports = __webpack_public_path__ + "static/img/inner-corner-quarter-pipe_256.c58e01e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inner-corner-quarter-pipe_256.png
// module id = FjN0
// module chunks = 0